import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60f4b83d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "home-component" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "logo-theme" })
], -1))
const _hoisted_5 = { class: "col-12 info-col" }
const _hoisted_6 = { id: "test-name" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "open-sans-font info-test" }, " Faça seu teste e receba as orientações, para cuidar de você e de quem você ama. ", -1))
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { class: "test-image-container" }
const _hoisted_10 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonStartTest = _resolveComponent("ButtonStartTest")!
  const _component_base_footer = _resolveComponent("base-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.testName), 1),
          _hoisted_7
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_ButtonStartTest, { onClick: _ctx.GAinitRegisterTest }, null, 8, ["onClick"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("img", { src: _ctx.testImage }, null, 8, _hoisted_10)
    ]),
    _createVNode(_component_base_footer)
  ]))
}